<script>
  export let offerText = '';
</script>

<div class="sticky-bar">
  <p>{offerText}</p>
</div>

<style>
  .sticky-bar {
    text-align: center;
    font-family: 'Inter';
    background-color: #fe5900;
    color: white;
    padding: 1rem;
    font-size: 1.5rem;
    letter-spacing: 1.2px;
  }
</style>
